"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saleItemFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
exports.saleItemFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    sale_id: 2,
    name: 'Test',
    quantity: 1,
    price: Mocks.clare.amountTen,
    price_cents: Mocks.clare.numberTen,
    amount: Mocks.clare.amountTen,
    amount_cents: Mocks.clare.numberTen,
    upfront_amount: Mocks.clare.amountTen,
    shipped_at: Mocks.dates.date2000,
    created_at: Mocks.dates.date2000,
    item_variation_id: 3,
    sale_number: Mocks.clare.saleNumber,
    paid_on: Mocks.dates.date2000,
    store_id: Mocks.clare.storeId,
    is_paid: true,
    full_name: Mocks.persona.full_name,
    item_uuid: Factory.each(i => uuid_1.v4()),
    item_variation_uuid: Factory.each(i => uuid_1.v4()),
    use_flat_fee: false,
    fees_total: Mocks.clare.amountZero,
    currency: Mocks.clare.usd,
    prior_amount: Mocks.clare.amountZero,
    image: Mocks.clare.image,
    amount_discounted: Mocks.clare.amountZero,
    adjusted_amount: Mocks.clare.amountZero
});
